const UserHashtagReport = {

	visual: {
		icon: "va-icon fa fa-line-chart",
		title: "Hashtag Usage by Account Report",
		desc: "Analysis of accounts using specified hashtag."
	},

	binding: [
	{"hashtag_useage_text": "string","label":"Hashtag"},
	{"hashtag_useage_limit": "number", "label":"Return limit"}
	],

	query:`
	MATCH 
		(h:Hashtag {text: ':hashtag_useage_text'})-[:HASHTAG_OF]->(s:Status)-[:POSTED_BY]->(a:Account) 
	WITH 
		h,collect(distinct a) as accs 
		UNWIND 
			accs as acc  
		MATCH 
			(h2:Hashtag {text: ':hashtag_useage_text'})-[:HASHTAG_OF]->(s2:Status)-[:POSTED_BY]->(a2:Account) 
		WHERE 
			a2.id = acc.id WITH h, acc, COUNT(s2) as s_count 		
		CALL 
			apoc.create.vRelationship(h,'USED_HASHTAG',{count: s_count}, acc) 
		YIELD 
			rel 
	RETURN 
		acc, rel, h 
	ORDER BY 
		(CASE s_count WHEN null THEN {} ELSE s_count END) 
	DESC LIMIT 
		:hashtag_useage_limit
	`,

	config:{
		console_debug:false,
		labels: {
			"Account": {
				"caption": "screen_name"
			},
			"Hashtag": {
				"caption": "hashtag"
			}
		},
		relationships: {
			"USED_HASHTAG": {
				"thickness": "count",
				"caption": false
			}
		},
	}
	
}

export default UserHashtagReport;
